<template>
<div>
  <div class="bk-gray-dark bk-gray-dark-margin">
    <div class="logo-secret">
            <img src="../../assets/images/image-secretele-laptelui/celule-imunitare.png" style="width: 54px; height: 53px">
        </div>
        <h3>Influențează celulele imunitare </h3>
        <p>Oligozaharidele din laptele matern au impact direct asupra sistemului imunitar, deoarece stimulează celulele imunitare să reacționeze la potențialele amenințări.</p>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
}
</script>
<style scoped lang="scss">

</style>
